// 由 EB view/admin/src/router/modules/systemForm.js 自动转换
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016-2026 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router'
import { roterPre } from '@/setting';
const systemFormRouter: RouteRecordRaw =
    {
      path: `${roterPre}/systemForm`,
      name: 'system',
      meta: {
        icon: 'dashboard',
        title: '商城设置'
      },
      alwaysShow: true,
      component: Layout,
      children: [
        {
          path: 'Basics/:key?/:tab?',
          component: () => import('@/views/systemForm/setSystem/index.vue'),
          name: 'Basics',
          meta: { title: '基础配置' }
        },
        {
          path: 'delivery',
          component: () => import('@/views/systemForm/cityDelivery/index.vue'),
          name: 'Delivery',
          meta: { title: '同城配送' }
        },
        {
          path: 'customer_keyword',
          component: () => import('@/views/system/customer_keyword/index.vue'),
          name: 'CustomerKeyword',
          meta: { title: '自动回复' }
        },
        {
          path: 'form_list',
          component: () => import('@/views/systemForm/form/index.vue'),
          name: 'FormList',
          meta: { title: '系统表单' }
        },
        {
          path: 'form_create',
          component: () => import('@/views/systemForm/form/create.vue'),
          name: 'CreateForm',
          meta: {
            title: '添加系统表单',
            activeMenu: `${roterPre}/systemForm/form_list`
          }
        },
        {
          path: 'form_detail/:id?',
          component: () => import('@/views/systemForm/form/details.vue'),
          name: 'FormDetail',
          meta: {
            title: '表单详情',
            activeMenu: `${roterPre}/systemForm/form_list`
          }
        }
      ]
    }

export default systemFormRouter;
